import { render, staticRenderFns } from "./fsDialog_component.vue?vue&type=template&id=edc7975a&scoped=true&"
import script from "./fsDialog_component.vue?vue&type=script&lang=js&"
export * from "./fsDialog_component.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "edc7975a",
  null
  
)

export default component.exports